// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__VuyiV","footer":"ModalInfo_footer__1vGpj"};